import bact from '@/sui/data/sheets/edit/bact'
import patient from '@/sui/data/sheets/edit/patient'
import tools from '@/sui/data/sheets/edit/tools'
import notes from '@/sui/data/sheets/edit/notes/bactADI'
import fields from '@/sui/data/sheets/edit/fields'

const y2019 = {
  titles: {
    future: {
      text: 'DEVENIR DU PATIENT 7 JOURS APRÈS LE DIAGNOSTIC DE LA BACTÉRIÉMIE',
      start: 'future'
    }
  }
}

const current = {
  titles: {
    patient: {
      text: 'DONNÉES ADMINISTRATIVES DU PATIENT',
      start: fields.unitType
    },

    bact: {
      text: 'DONNÉES RELATIVES À LA BACTÉRIÉMIE ASSOCIÉE AUX SOINS',
      start: fields.episod
    },

    death: {
      text: `DEVENIR DU PATIENT 7 JOURS APRÈS LA DATE DE L'ÉPISODE`,
      start: fields.dead
    }
  }
}

export default {
  '2026': {
    titles: [
      current.titles.patient,
      current.titles.death,
      current.titles.bact
    ],

    fields: [
      patient.sheetNumber.v2,
      patient.unitType.v2.rw,
      patient.uf,
      patient.birthdate,
      patient.sex,
      patient.entrydate,
      patient.immuno,
      patient.cancer,
      patient.mixManagment,
      tools.select(patient.patientOrigin.v3, patient.select.isAdPedOrPedMix),
      tools.select(patient.bmi, patient.select.isAdPedOrPedMix),
      tools.select(patient.neoOrigin, patient.select.isNeoOrNeoMix),
      tools.select(patient.birthWeight, patient.select.isNeoOrNeoMix),
      tools.select(patient.gestationalAge, patient.select.isNeoOrNeoMix),
      patient.dead,
      patient.deathDate,
      ...bact.all.v8.flat
    ],

    buildNotes: function (result, sheet, surveillance) {
      notes.build2026(result, sheet, surveillance)
      return result
    }
  },

  '2025': {
    titles: [
      current.titles.patient,
      current.titles.death,
      current.titles.bact
    ],

    fields: [
      patient.sheetNumber.v2,
      patient.unitType.v2.rw,
      patient.uf,
      patient.birthdate,
      patient.sex,
      patient.entrydate,
      patient.immuno,
      patient.cancer,
      patient.mixManagment,
      tools.select(patient.patientOrigin.v3, patient.select.isAdPedOrPedMix),
      tools.select(patient.bmi, patient.select.isAdPedOrPedMix),
      tools.select(patient.neoOrigin, patient.select.isNeoOrNeoMix),
      tools.select(patient.birthWeight, patient.select.isNeoOrNeoMix),
      tools.select(patient.gestationalAge, patient.select.isNeoOrNeoMix),
      patient.dead,
      patient.deathDate,
      ...bact.all.v7.flat
    ],

    buildNotes: function (result, sheet, surveillance) {
      notes.build2025(result, sheet, surveillance)
      return result
    }
  },

  '2024': {
    titles: [
      current.titles.patient,
      current.titles.death,
      current.titles.bact
    ],

    fields: [
      patient.sheetNumber.v2,
      patient.unitType.v2.rw,
      patient.uf,
      patient.birthdate,
      patient.sex,
      patient.entrydate,
      patient.immuno,
      patient.cancer,
      patient.mixManagment,
      tools.select(patient.patientOrigin.v3, patient.select.isAdPedOrPedMix),
      tools.select(patient.bmi, patient.select.isAdPedOrPedMix),
      tools.select(patient.neoOrigin, patient.select.isNeoOrNeoMix),
      tools.select(patient.birthWeight, patient.select.isNeoOrNeoMix),
      tools.select(patient.gestationalAge, patient.select.isNeoOrNeoMix),
      patient.dead,
      patient.deathDate,
      ...bact.all.v6.flat
    ],

    buildNotes: function (result, sheet, surveillance) {
      notes.build2024(result, sheet, surveillance)
      return result
    }
  },

  '2023': {
    titles: [
      current.titles.patient,
      current.titles.death,
      current.titles.bact
    ],

    fields: [
      patient.sheetNumber.v2,
      patient.unitType.v1.rw,
      patient.uf,
      patient.birthdate,
      patient.sex,
      patient.entrydate,
      patient.immuno,
      patient.cancer,
      patient.mixManagment,
      tools.select(patient.patientOrigin.v3, patient.select.isAdPedOrPedMix),
      tools.select(patient.bmi, patient.select.isAdPedOrPedMix),
      tools.select(patient.neoOrigin, patient.select.isNeoOrNeoMix),
      tools.select(patient.birthWeight, patient.select.isNeoOrNeoMix),
      tools.select(patient.gestationalAge, patient.select.isNeoOrNeoMix),
      patient.dead,
      patient.deathDate,
      ...bact.all.v5.flat
    ],

    buildNotes: function (result, sheet, surveillance) {
      notes.build2023(result, sheet, surveillance)
      return result
    }

  },

  '2022': {
    titles: [
      current.titles.patient,
      current.titles.death,
      current.titles.bact
    ],

    fields: [
      patient.sheetNumber.v2,
      patient.unitType.v1.rw,
      patient.uf,
      patient.birthdate,
      patient.sex,
      patient.entrydate,
      patient.immuno,
      patient.cancer,
      patient.mixManagment,
      tools.select(patient.patientOrigin.v3, patient.select.isAdPedOrPedMix),
      tools.select(patient.neoOrigin, patient.select.isNeoOrNeoMix),
      tools.select(patient.birthWeight, patient.select.isNeoOrNeoMix),
      tools.select(patient.gestationalAge, patient.select.isNeoOrNeoMix),
      patient.dead,
      patient.deathDate,
      ...bact.all.v4.flat
    ],

    buildNotes: function (result, sheet, surveillance) {
      notes.build2022(result, sheet, surveillance)
      return result
    }
  },

  '2021': {
    titles: [
      current.titles.patient,
      current.titles.death,
      current.titles.bact
    ],

    fields: [
      patient.sheetNumber.v2,
      patient.unitType.v1.rw,
      patient.uf,
      patient.birthdate,
      patient.sex,
      patient.entrydate,
      patient.immuno,
      patient.cancer,
      patient.mixManagment,
      tools.select(patient.patientOrigin.v3, patient.select.isAdPedOrPedMix),
      tools.select(patient.neoOrigin, patient.select.isNeoOrNeoMix),
      tools.select(patient.birthWeight, patient.select.isNeoOrNeoMix),
      tools.select(patient.gestationalAge, patient.select.isNeoOrNeoMix),
      patient.dead,
      patient.deathDate,
      ...bact.all.v3.flat
    ],

    buildNotes: function (result, sheet, surveillance) {
      notes.build2021(result, sheet, surveillance)
      return result
    }
  },

  '2020': {
    titles: [
      current.titles.patient,
      current.titles.death,
      current.titles.bact
    ],

    fields: [
      patient.sheetNumber.v2,
      patient.unitType.v1.rw,
      patient.uf,
      patient.birthdate,
      patient.sex,
      patient.entrydate,
      patient.immuno,
      patient.cancer,
      patient.mixManagment,
      tools.select(patient.patientOrigin.v2, patient.select.isAdPedOrPedMix),
      tools.select(patient.neoOrigin, patient.select.isNeoOrNeoMix),
      tools.select(patient.birthWeight, patient.select.isNeoOrNeoMix),
      tools.select(patient.gestationalAge, patient.select.isNeoOrNeoMix),
      patient.dead,
      patient.deathDate,
      ...bact.all.v2.flat
    ],

    buildNotes: function (result, sheet) {
      notes.build2020(result, sheet)
      return result
    }
  },

  '2019': {

    titles: [
      current.titles.patient,
      current.titles.bact,
      y2019.titles.future
    ],

    fields: [
      patient.sheetNumber.v1,
      patient.unitType.v1.rw,
      patient.uf,
      patient.birthdate,
      patient.sex,
      patient.entrydate,
      patient.mixManagment,
      patient.patientOrigin.v1,
      patient.immuno,
      tools.select(patient.birthWeight, patient.select.isNeoOrNeoMix),
      tools.select(patient.gestationalAge, patient.select.isNeoOrNeoMix),
      ...bact.all.v1.flat,
      patient.future,
      patient.deathDateWithFuture
    ],

    buildNotes: function (result, sheet) {
      notes.build2019(result, sheet)
      return result
    }
  }
}
